import React, { memo } from "react";
import { BoxIcons, IconTypes } from "us.icons";
import { $DateLabel, $Tooltip } from "us.common/components";
import { getBoxIconByFileFormat } from "us.collection.documents/functions";
import { getFileNameFromPath } from "us.collection.case/components/Detail/NotesAndMessages/functions";

type printedDocumentsProps = {
  documents: any;
  handleAttachment: (file: string, filePath: string) => void;
};

/**
 * @description - Pinned followups list item component
 */
const PrintedDocuments: React.FC<printedDocumentsProps> = ({
  documents,
  handleAttachment,
}) => {
  return documents?.map((document: any) => {
    const {
      outputInfo,
      activityName,
      messageType,
      executedTime,
      activityHistoryId,
      activityCode
    } = document;
    const fileName = getFileNameFromPath(outputInfo);

    return (
      <div key={activityHistoryId} className="msg-temp-thumb">
        <div className="msg-temp-thumb-inner">
          <div
            className="msg-temp-thumb-content"
            onClick={() => handleAttachment(activityName, outputInfo)}
          >
            <div className="msg-temp-thumb-icon">
              <BoxIcons
                type={IconTypes.BOX_ICON}
                name={getBoxIconByFileFormat("." + messageType)}
              />
            </div>
            <$Tooltip
              overlayClassName="msg-temp-thumb-tooltip"
              placement="topLeft"
              title={fileName}
            >
              <div className="msg-temp-thumb-desc">
                <div className="msg-temp-thumb-name">{activityName}</div>
                <div className="msg-temp-thumb-date">
                  <$DateLabel value={executedTime} />
                </div>
              </div>
            </$Tooltip>
          </div>
        </div>
      </div>
    );
  });
};

export default memo(PrintedDocuments);
